import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import Drawer from '@material-ui/core/Drawer'
import { fade } from '@material-ui/core/styles/colorManipulator'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { compose } from 'recompose'

import {
  BookingListItems,
  SecondaryListItems,
  ErrorReportListItems,
  InfoListItems,
  NewsListItems,
  BookingSystemListItems
} from '../../common/listItems'
import Header from '../../common/header'

import * as Constants from '../../../helpers/Constants'
import * as configActions from '../../../actions/Config'
import * as userActions from '../../../actions/User'
import * as Strings from './strings'

const drawerWidth = 240

class MenuHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      height: window.innerHeight,
      width: window.innerWidth
    }
    this.resizeHandler = this.resizeHandler.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  resizeHandler() {
    this.setState({ height: window.innerHeight, width: window.innerWidth })
  }

  navigateTo(page) {
    const { user, history } = this.props
    if (user.offlineModeSignedIn) {
      history.push('/testmode' + page)
    } else {
      history.push(page)
    }
  }

  render() {
    const {
      classes,
      children,
      config,
      user,
      header,
      selected,
      data
    } = this.props
    const { height, width } = this.state
    const extraWidth = config.menuOpen ? 240 : 72
    const contentWidth = width - extraWidth

    if (!user.fetched) {
      return null
    }

    return (
      <React.Fragment>
        <CssBaseline />
        <div style={{ display: 'flex' }}>
          <Header
            language={config.language}
            changeLanguage={() =>
              this.props.setLanguage(config.language === 'SE' ? 'EN' : 'SE')
            }
            open={config.menuOpen}
            onClose={() => this.props.toggleMenu()}
            header={header}
          />
          <Drawer
            variant={'permanent'}
            classes={{
              paper: classNames(
                classes.drawerPaper,
                !config.menuOpen && classes.drawerPaperClose
              )
            }}
            open={config.menuOpen}
          >
            <div
              style={{
                height: 64,
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <IconButton onClick={() => this.props.toggleMenu()}>
                <ChevronLeftIcon />
              </IconButton>
            </div>
            <Divider />
            <BookingListItems
              selected={selected}
              language={config.language}
              navigateTo={page => this.navigateTo(page)}
              show={data.privileges.laundryBookingSystem}
            />
            <BookingSystemListItems
              selected={selected}
              language={config.language}
              navigateTo={page => this.navigateTo(page)}
              show={data.privileges.bookingSystem}
            />
            <ErrorReportListItems
              selected={selected}
              language={config.language}
              navigateTo={page => this.navigateTo(page)}
              show={data.privileges.errorReportSystem}
            />
            <NewsListItems
              selected={selected}
              language={config.language}
              navigateTo={page => this.navigateTo(page)}
              show={data.privileges.feedSystem}
            />
            <InfoListItems
              selected={selected}
              language={config.language}
              navigateTo={page => this.navigateTo(page)}
              show={data.privileges.infoSystem}
            />
            <SecondaryListItems
              selected={selected}
              language={config.language}
              navigateTo={page => this.navigateTo(page)}
              signOut={() =>
                this.props.showAlert(
                  Strings.default.SIGN_OUT[config.language],
                  Strings.default.SIGN_OUT_HEADER[config.language],
                  Constants.TWO_BUTTONS,
                  {
                    title: Strings.default.NO[config.language],
                    onPress: () => {}
                  },
                  {
                    title: Strings.default.YES[config.language],
                    onPress: user.offlineModeSignedIn
                      ? () => (window.location = 'https://homepal.se/pris')
                      : () => this.props.signout()
                  }
                )
              }
              showToAssoicationSettings={user.isAdmin}
            />
          </Drawer>
          <div style={{ minHeight: height, width: contentWidth }}>
            {children}
          </div>
        </div>
      </React.Fragment>
    )
  }
}

const Styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0)',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36
  },
  menuButtonHidden: {
    display: 'none'
  },
  title: {
    flexGrow: 1
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9
    }
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  },
  chartContainer: {
    marginLeft: -22
  },
  grow: {
    flexGrow: 1
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit,
      width: 'auto'
    },
    height: 40,
    marginRight: 15
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200
      }
    }
  },
  selectCommunityButton: {
    borderColor: 'white',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    },
    textTransform: 'none',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 'bold',
    marginRight: 15
  },
  textStyle: {
    textTransform: 'none',
    fontFamily: 'Lato',
    fontSize: 16
  },
  toolbar: {
    display: 'flex',
    height: 64
  }
})

function mapStateToProps({ config, user, data }) {
  return { config, user, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...userActions }, dispatch)
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withStyles(Styles)
)(MenuHeader)



// WEBPACK FOOTER //
// ./src/components/containers/MenuHeader/index.js